import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

export function useUser(userId) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setUser(null);
      setLoading(false);
      return () => {};
    }

    const db = firebase.firestore();
    setLoading(true);
    const unsubscribe = db.collection('users').doc(userId).onSnapshot((doc) => {
      if (!doc.exists) {
        setUser(null);
      } else {
        setUser({
          id: doc.id,
          ...doc.data(),
        });
      }
      setLoading(false);
    }, (error) => {
      console.error('[useUser] Failed to load user:', error);
      setUser(null);
      setLoading(false);
    });

    return () => {
      unsubscribe();
      setLoading(false);
    };
  }, [userId]);

  return [loading, user];
}
